import React from 'react';
import PropTypes from 'prop-types';

const MarcusInvestDisclaimer = ({ advLink }) => (
  <div className="disclaimer">
    You are being referred to Goldman Sachs & Co. LLC’s website (&quot;Marcus by
    Goldman Sachs&quot;) by NerdWallet Inc. (NerdWallet). Marcus by Goldman
    Sachs and NerdWallet have entered into a written referral agreement by which
    NerdWallet will be paid $8 (“Referral Fee”) for each individual user who
    visits the Marcus by Goldman Sachs webpage via this link. The Referral Fee
    is paid regardless of whether or not you become a client. NerdWallet is not
    affiliated with Goldman Sachs & Co. LLC and NerdWallet&apos;s services
    consist solely of referrals of individual users to the Marcus by Goldman
    Sachs webpage. No fees or other amounts will be charged to individual users,
    prospective clients, or clients by NerdWallet or Marcus by Goldman Sachs as
    a result of the referral arrangement. Individual users and prospective
    clients that are referred to Marcus by Goldman Sachs and subsequently
    subscribe for investment advisory services provided by Marcus by Goldman
    Sachs’ affiliated adviser, GS&Co. will not pay increased management fees or
    other similar compensation to NerdWallet, Marcus by Goldman Sachs or GS&Co.
    as a result of this arrangement.{` `}
    {advLink && (
      <span>
        Additional information about GS&Co. is contained in Form ADV Part 2A
        available&nbsp;
        <a href={advLink}>here</a>.&nbsp;
      </span>
    )}
    Ancillary fees may apply. Investments involve risk and may lose value.
    Please consider your objectives before investing. Brokerage/advisory
    services by Goldman Sachs & Co. LLC. Member SIPC. For more information about
    Marcus Invest offerings, visit our{' '}
    <a
      target="_blank"
      rel="noreferrer"
      href="https://www.marcus.com/us/en/disclosure/invest-disclosures"
    >
      Full Disclosures
    </a>
    .
  </div>
);

MarcusInvestDisclaimer.propTypes = {
  advLink: PropTypes.string,
};

MarcusInvestDisclaimer.displayName = 'MarcusInvestDisclaimer';

export default MarcusInvestDisclaimer;
